export default "__VITE_ASSET__e96sEyim__"